import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { Checkbox, Divider } from 'antd';

import { SET_FILTERS_INVENTORIES } from '~/redux/actions/DatailedReportFiltersActions';
import { ToastContext } from '~/providers/ToastProvider';
import { InventoryRoutes } from '~/http/routes';

function Inventory() {
	const dispatch = useDispatch();
	const { companyId } = useSelector(state => state.userStore);
	const { inventories } = useSelector(state => state.detailedReportFilters);

	const { setToast } = useContext(ToastContext);
	const [companyInventories, setCompanyInventories] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(async () => {
		try {
			setCompanyInventories((await InventoryRoutes.getInventory(companyId)).data.data);
			setIsLoading(false);
		} catch (err) {
			setToast({
				type: 'error',
				title: 'Erro!',
				message: 'Um erro ocorreu ao buscar os inventários da empresa!',
				show: true,
				autohide: true,
			});
			setIsLoading(false);
		}
	}, []);

	function setInventories(e) {
		dispatch({ type: SET_FILTERS_INVENTORIES, data: e });
	}

	function handleCheck(e) {
		const aux = inventories;
		const index = aux.findIndex(inv => inv == e);

		if (index > -1)
			aux.splice(index, 1);
		else
			aux.push(e);

		setInventories(aux);
	}

	function handleCheckAll(e) {
		if (e.target.checked)
			setInventories(companyInventories.map(e => e.id));
		else
			setInventories([]);
	}

	if (isLoading)
		return (
			<div className="d-flex justify-content-center">
				<Spinner animation="border"
					role="status" />
			</div>
		);

	return (
		<>
			<div className="row">
				<div className="col-sm-12">
					<Checkbox checked={inventories.length === companyInventories.length}
						indeterminate={inventories.length !== companyInventories.length}
						onChange={handleCheckAll}>
						Marcar todos
					</Checkbox>
				</div>

				<Divider />
			</div>

			<div className="row">
				{companyInventories.map(({ name, id }, i) => (
					<div key={i}
						className="col-sm-12 col-md-6 col-lg-4 col-xl-3">
						<Checkbox checked={inventories.find(e => e == id)}
							onChange={handleCheck.bind(null, id)}>
							{name}
						</Checkbox>

						<Divider />
					</div>
				))}
			</div>
		</>
	);
}

export default Inventory;
